import React, { useContext } from 'react';
import ModalContext from '../Modal/ModalContext';
import InviteAdminModal from '../Modal/AdminModal';

// Use this component as the base for a modal comment
// form so that the modal's buttons have access to submit the form.
function ModalInviteAdmin(props) {
  const { setSubmitFn, setSubmitDisabled } = useContext(ModalContext);

  return (
    <InviteAdminModal
      {...props}
      setOuterSubmitFn={setSubmitFn}
      setOuterSubmitDisabled={setSubmitDisabled}
    />
  );
}

export default ModalInviteAdmin;
